import {
  SET_FIRST_TIMECODE_INDEX,
  UPDATE_READ_ONLY,
  SET_EDITTABLE_HEIGHT,
  SET_COLHEADERS,
  SET_CELL,
  UPDATE_COLUMNS_WIDTH,
  SET_COLUMNS,
  SET_SHOW_SOURCE_STATUS,
  SET_ORG_TIME_STRING,
  SET_NEW_TIME_STRING,
  SET_readOnly,
  INIT_DATA,
  SET_SHOW_SHOT_CHANGE_STATUS,
} from './types';
import DataObj from '../class/DataObj';

//設定編輯或是閱讀
export const addTenRow = (tableData) => (dispatch) => {
  let newtableData = tableData;

  //先檢查尾部有多少資料是空的

  let AddNullCount = 0;

  for (let i = tableData.length - 1; i >= 0; i--) {
    const dataObj = tableData[i];

    const { In, Out } = dataObj;

    if (In === '' && Out === '') {
      AddNullCount += 1;
    } else {
      break;
    }
  }

  if (AddNullCount < 10) {
    for (let i = 0; i < 10 - AddNullCount; i++) {
      const emp = new DataObj();

      newtableData.push(emp);
    }
  }

  dispatch({
    type: INIT_DATA,
    payload: newtableData,
  });
};

//設定編輯或是閱讀
export const setReadonly = (ReadonlyReault) => (dispatch) => {
  dispatch({
    type: SET_readOnly,
    payload: ReadonlyReault,
  });
};
export const setCellClass = (editTable_data) => (dispatch) => {
  let cell = [];
  for (let i = 0; i < editTable_data.length; i++) {
    for (let j = 0; j < 9; j++) {
      cell.push({ row: i, col: j, className: 'htCenter htBottom' });
    }
  }

  dispatch({
    type: SET_CELL,
    payload: cell,
  });
};

/**
 *
 * @param {*} colName 名稱
 * @param {*} SourceTargetWidth 中間最長的兩個寬度 (預設為0)
 * @returns
 */
function getWidthBy_colHeadersName(colName, SourceTargetWidth) {
  switch (colName) {
    case 'In TC':
      return 80;
    case 'Out TC':
      return 80;
    case 'Shot change':
      return 80;
    case 'Dur':
      return 47;
    case 'Memo':
      return 75;
    case 'Char':
      return 40;
    case 'Pos':
      return 40;
    default:
      return SourceTargetWidth;
  }
}

export const setTableColWidth = (tableWidth, type, editTable) => (dispatch) => {
  // console.log(`tableWidth ${tableWidth}`);

  // 取得 Source Target 的總量
  let SourceTargetCount = 0;
  if (editTable.colHeaders.includes('Source')) {
    SourceTargetCount += 1;
  }
  if (editTable.colHeaders.includes('Target')) {
    SourceTargetCount += 1;
  }

  let SourceTargetWidth = 0;

  let totalC = 0;
  editTable.colHeaders.map((_colName) => {
    totalC += getWidthBy_colHeadersName(_colName, 0);
  });

  // 取出 Source 與 Target 的寬度
  SourceTargetWidth = ((tableWidth - totalC) / SourceTargetCount) * 0.95;

  let payloadArray = [];
  editTable.colHeaders.map((_colName) => {
    payloadArray.push(getWidthBy_colHeadersName(_colName, SourceTargetWidth));
  });

  dispatch({
    type: UPDATE_COLUMNS_WIDTH,
    payload: payloadArray,
  });

  return;
  // tableWidth 表格總寬度
  let TcWidth = 80;
  let Dur = 47;
  let memo = 75;
  let leftWidth = tableWidth - TcWidth * 2 - Dur * 3 - memo - 30;
  if (type === 1) {
    //顯示Source

    dispatch({
      type: UPDATE_COLUMNS_WIDTH,
      payload: [
        TcWidth,
        TcWidth,
        Dur,
        memo,
        leftWidth / 2,
        leftWidth / 2,
        Dur,
        Dur,
      ],
    });
  } else if (type === 0) {
    //基本 [80, 80,50, 80,120, 310, 50,50]
    //原本設計寬度 820

    dispatch({
      type: UPDATE_COLUMNS_WIDTH,
      payload: [TcWidth, TcWidth, Dur, memo, leftWidth, Dur, Dur],
    });
  } else if (type === 2) {
    //顯示 shot change
    dispatch({
      type: UPDATE_COLUMNS_WIDTH,
      payload: [
        TcWidth,
        TcWidth,
        TcWidth,
        Dur,
        memo,
        leftWidth - TcWidth,
        Dur,
        Dur,
      ],
    });
  }
};

//設定TC凍結
export const set_COLUMNS_TimecodeLock = (orgCOLUMNS) => (dispatch) => {
  let finalCOLUMNS = [];
  orgCOLUMNS.map((wdata) => {
    const { data } = wdata;

    if (data === 'In') {
      finalCOLUMNS.push({ data: 'In', renderer: 'html', editor: false });
    } else if (data === 'Out') {
      finalCOLUMNS.push({ data: 'Out', renderer: 'html', editor: false });
    } else {
      finalCOLUMNS.push(wdata);
    }
  });

  dispatch({
    type: SET_COLUMNS,
    payload: finalCOLUMNS,
  });
};
export const show_source_language = (orgCOLUMNS, _editTable) => (dispatch) => {
  // Source
  const newPayload = [];
  _editTable.colHeaders.reverse().map((head) => {
    newPayload.push(head);
    if (head === 'Target') {
      newPayload.push('Source');
    }
  });

  dispatch({
    type: SET_COLHEADERS,
    payload: newPayload.reverse(),
  });

  dispatch({
    type: SET_SHOW_SOURCE_STATUS,
    payload: true,
  });

  let finalCOLUMNS = [];
  orgCOLUMNS.map((wdata, index) => {
    const { data } = wdata;
    finalCOLUMNS.push(wdata);

    if (data === 'Memo') {
      finalCOLUMNS.push({ data: 'Source', renderer: 'html', editor: false });
    }
  });

  dispatch({
    type: SET_COLUMNS,
    payload: finalCOLUMNS,
  });
};

export const hide_source_language = (orgCOLUMNS, _editTable) => (dispatch) => {
  var filteredArray = _editTable.colHeaders.filter(function (e) {
    return e !== 'Source';
  });

  dispatch({
    type: SET_COLHEADERS,
    payload: filteredArray,
  });

  dispatch({
    type: SET_SHOW_SOURCE_STATUS,
    payload: false,
  });

  let finalCOLUMNS = [];
  orgCOLUMNS.map((wdata, index) => {
    const { data } = wdata;
    if (data === 'Source') {
    } else {
      finalCOLUMNS.push(wdata);
    }
  });

  dispatch({
    type: SET_COLUMNS,
    payload: finalCOLUMNS,
  });
};

export const show_hide_Shot_Change =
  (orgCOLUMNS, isShow, _editTable) => (dispatch) => {
    let finalCOLUMNS = [];

    if (isShow === true) {
      // 顯示
      const newPayload = [];
      _editTable.colHeaders.map((head) => {
        newPayload.push(head);
        if (head === 'Out TC') {
          // 加過不要在加
          const isShowShotchangeAlredy =
            _editTable.colHeaders.includes('Shot change');
          if (isShowShotchangeAlredy !== true) {
            newPayload.push('Shot change');
          }
        }
      });

      dispatch({
        type: SET_COLHEADERS,
        payload: newPayload,
      });

      dispatch({
        type: SET_SHOW_SHOT_CHANGE_STATUS,
        payload: true,
      });

      orgCOLUMNS.map((wdata, index) => {
        const { data } = wdata;

        finalCOLUMNS.push(wdata);

        if (data === 'Out') {
          //check next
          const nextData = orgCOLUMNS[index + 1];
          const { data } = nextData;
          if (data !== 'ShotChange') {
            finalCOLUMNS.push({
              data: 'ShotChange',
              renderer: 'html',
              editor: false,
            });
          }
        }
      });
    } else {
      // 移除
      const newPayload = _editTable.colHeaders.filter(function (e) {
        return e !== 'Shot change';
      });

      dispatch({
        type: SET_COLHEADERS,
        payload: newPayload,
      });

      dispatch({
        type: SET_SHOW_SHOT_CHANGE_STATUS,
        payload: false,
      });

      orgCOLUMNS.map((wdata, index) => {
        const { data } = wdata;
        if (data === 'ShotChange') {
        } else {
          finalCOLUMNS.push(wdata);
        }
      });
    }

    dispatch({
      type: SET_COLUMNS,
      payload: finalCOLUMNS,
    });
  };

export const onBeforeHotChange = (changes, source) => (dispatch) => {};

export const setEditTableHeight = (height) => (dispatch) => {
  dispatch({
    type: SET_EDITTABLE_HEIGHT,
    payload: height,
  });

  return false;
};

export const toggleReadOnly = (event) => (dispatch) => {
  // console.log(event.target.checked)

  dispatch({
    type: UPDATE_READ_ONLY,
    payload: event.target.checked,
  });

  return false;
};

export const set_first_timeCode_index = (index) => (dispatch) => {
  dispatch({
    type: SET_FIRST_TIMECODE_INDEX,
    payload: index,
  });
};
export const setOrgTimeString = (orgTimeString) => (dispatch) => {
  dispatch({
    type: SET_ORG_TIME_STRING,
    payload: orgTimeString,
  });
};
export const setNewTimeString = (newTimeString) => (dispatch) => {
  dispatch({
    type: SET_NEW_TIME_STRING,
    payload: newTimeString,
  });
};



// WEBPACK FOOTER //
// ./src/actions/editTableActions.js